export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13865.f8b3d531.jpg";